import React from "react";
import AIAssitIco from "../../../assets/icons/AIAssitIco";
import CandidateIco from "../../../assets/icons/CandidateIco";
import CRMIco from "../../../assets/icons/CRMIco";
import HomeIco from "../../../assets/icons/HomeIco";
import { default as HyperQuickMatchIco } from "../../../assets/icons/HyperQuickMatchIco";
import { default as JobNavIco } from "../../../assets/icons/JobNavIco";
import KlarityCrystalpathIco from "../../../assets/icons/KrystalPathIco";
import ProjectIco from "../../../assets/icons/ProjectIco";
import ReportIco from "../../../assets/icons/ReportIco";
import SendFeedBackIco from "../../../assets/icons/SendFeedBackIco";

export const RecruitingAgency = ({ storageData, open }) => [
  {
    name: "Home",
    path: "/home",
    icon: <HomeIco />,
  },

  ...(!open
    ? [
        {
          name: "Jobs",
          icon: <JobNavIco />,
          path: true,
        },
        {
          name: "Candidates",
          icon: <CandidateIco />,
          path: true,
        },
        {
          name: "Matches",
          icon: <HyperQuickMatchIco />,
          path: true,
        },
        {
          name: "Projects",
          icon: <ProjectIco />,
          path: true,
        },

        ...(storageData?.role === "Admin"
          ? [
              {
                name: "CRM",
                icon: <CRMIco />,
                path: true,
              },
            ]
          : []),

        {
          name: "Reports",
          icon: <ReportIco />,
          path: true,
        },

        {
          name: "Ai Assist",
          icon: <AIAssitIco />,
          path: true,
        },
      ]
    : [
        {
          name: "Jobs",
          icon: <JobNavIco />,
          children: [
            {
              name: "Enrich Job",
              path: "/enrich-job",
            },
            {
              name: "Create New Job",
              path: "/create-new-job",
            },
            {
              name: "Job Hub",
              path: "/jobs",
            },
            {
              name: "Workflow Management",
              path: "/job-krystal-path",
              icon: <KlarityCrystalpathIco />,
            },
          ],
        },
        {
          name: "Candidates",
          icon: <CandidateIco />,
          children: [
            {
              name: "Enrich Resume",
              path: "/resume-intelligence/create-candidate-resume",
            },
            {
              name: "Candidate Hub",
              path: "/candidates",
            },
            {
              name: "Build Pipeline",
              path: "/build-pipeline",
              check: "common",
            },
            {
              name: "Upload Hotlist",
              path: "/subscription-expired?id=100",
              check: "common",
            },
            {
              name: "Optimize Resume",
              path: "/subscription-expired?id=3",
              check: "common",
            },
            {
              name: "Onboard/Offboard",
              path: "/subscription-expired?id=4",
              check: "common",
            },
            {
              name: "Assessments",
              path: "/subscription-expired?id=5",
              check: "common",
            },
          ],
        },
        {
          name: "Matches",
          icon: <HyperQuickMatchIco />,
          children: [
            {
              name: "Quick Match JD to Resume",
              path: "/tools/quick-match",
            },
            {
              name: "Candidate to Jobs",
              path: "/subscription-expired?id=6",
              check: "common",
            },
            {
              name: "Job to candidates",
              path: "/subscription-expired?id=7",
              check: "common",
            },
            {
              name: "Assess Team Fit",
              path:
                storageData?.role === "Demo"
                  ? "/access-team-fit"
                  : "/subscription-expired?id=8",
              check: "common",
            },
          ],
        },
        {
          name: "Projects",
          icon: <ProjectIco />,
          children: [
            {
              name: "Enrich SoW",
              path: "/sow-enrichment",
            },
            {
              name: "SoW Hub",
              path: "/judica",
            },
            {
              name: "Create New SOW",
              path: "/subscription-expired?id=9",
              check: "common",
            },
            {
              name: "Bid Management",
              path:
                storageData?.role === "Demo"
                  ? "/bid-management"
                  : "/subscription-expired?id=10",
              check: "common",
            },
            {
              name: "Create Proposal",
              path: "/subscription-expired?id=24",
              check: "common",
            },
          ],
        },
        ...(storageData?.role === "Admin"
          ? [
              {
                name: "CRM",
                icon: <CRMIco />,
                children: [
                  {
                    name: "Manage Agency Info",
                    path: "/agency-information",
                  },
                  {
                    name: "Manage Client Info",
                    path: "/client",
                  },
                  {
                    name: "Manage Vendor Info",
                    path: "/vendor",
                  },
                ],
              },
            ]
          : []),
        {
          name: "Reports",
          icon: <ReportIco />,
          children: [
            {
              name: "Set Goals",
              path: "/subscription-expired?id=17",
              check: "common",
            },
            {
              name: "Review Financial Data",
              path: "/subscription-expired?id=19",
              check: "common",
            },
            {
              name: "Review Productivity",
              path: "/review-productivity",
            },
            {
              name: "Trends",
              path: "/subscription-expired?id=20",
              check: "common",
            },
            {
              name: "Dashboards",
              check: "common",
              path:
                storageData?.role === "Demo"
                  ? "/report-dashBoard"
                  : "/subscription-expired?id=21",
            },
            {
              name: "Scorecards",
              path: "/subscription-expired?id=22",
              check: "common",
            },
          ],
        },
        {
          name: "Ai Assist",
          icon: <AIAssitIco />,
          children: [
            {
              name: "Job Agent",
              path: "/hiring-agent",
            },
            {
              name: "Recruiting Agent",
              path: "/recruiting-agent",
            },
            {
              name: "Project Manager Agent",
              path: "/subscription-expired?id=23",
              check: "common",
            },
            {
              name: "Growth Agent",
              path: "/growth-agent",
              check: "common",
            },
          ],
        },
      ]),
  {
    name: "Send Feedback",
    path: "feedback",
    icon: <SendFeedBackIco />,
  },
];

export const DeliveryAgency = ({ storageData, open }) => [
  {
    name: "Home",
    path: "/home",
    icon: <HomeIco />,
  },

  ...(!open
    ? [
        {
          name: "Jobs",
          icon: <JobNavIco />,
          path: true,
        },
        {
          name: "Candidates",
          icon: <CandidateIco />,
          path: true,
        },
        {
          name: "Matches",
          icon: <HyperQuickMatchIco />,
          path: true,
        },
        {
          name: "Projects",
          icon: <ProjectIco />,
          path: true,
        },

        ...(storageData?.role === "Admin"
          ? [
              {
                name: "CRM",
                icon: <CRMIco />,
                path: true,
              },
            ]
          : []),

        {
          name: "Reports",
          icon: <ReportIco />,
          path: true,
        },

        {
          name: "Ai Assist",
          icon: <AIAssitIco />,
          path: true,
        },
      ]
    : [
        {
          name: "Jobs",
          icon: <JobNavIco />,
          children: [
            {
              name: "Understand Jobs",
              path: "/enrich-job",
            },
            {
              name: "Submit Job",
              path: "/create-new-job",
            },
            {
              name: "Assigned Jobs",
              path: "/jobs",
            },
            {
              name: "Job Flow Dashboard",
              path: "/job-krystal-path",
              icon: <KlarityCrystalpathIco />,
            },
          ],
        },
        {
          name: "Candidates",
          icon: <CandidateIco />,
          children: [
            {
              name: "Enrich Resume",
              path: "/resume-intelligence/create-candidate-resume",
            },
            {
              name: "Talent Pool",
              path: "/candidates",
            },
            {
              name: "Candidate Pipeline",
              path: "/build-pipeline",
              check: "common",
            },
            {
              name: "Upload Hotlist",
              path: "/subscription-expired?id=100",
              check: "common",
            },
            {
              name: "Optimize Resume for JD",
              path: "/subscription-expired?id=3",
              check: "common",
            },
            {
              name: "Conduct Assessments",
              path: "/subscription-expired?id=5",
              check: "common",
            },
          ],
        },
        {
          name: "Matches",
          icon: <HyperQuickMatchIco />,
          children: [
            {
              name: "Quick Match talent to Job",
              path: "/tools/quick-match",
            },
            {
              name: "Match Bench to Job",
              path: "/subscription-expired?id=6",
              check: "common",
            },
            {
              name: "Assess Job to Bench fit",
              path: "/subscription-expired?id=7",
              check: "common",
            },
          ],
        },
        {
          name: "Projects",
          icon: <ProjectIco />,
          children: [
            {
              name: "Understand Client SoW",
              path: "/sow-enrichment",
            },
            {
              name: "SoW Hub",
              path: "/judica",
            },
            {
              name: "Create SoW",
              path: "/subscription-expired?id=9",
              check: "common",
            },
            {
              name: "Manage Bids",
              path:
                storageData?.role === "Demo"
                  ? "/bid-management"
                  : "/subscription-expired?id=10",
              check: "common",
            },
            {
              name: "Create new Proposal",
              path: "/subscription-expired?id=24",
              check: "common",
            },
          ],
        },
        ...(storageData?.role === "Admin"
          ? [
              {
                name: "CRM",
                icon: <CRMIco />,
                children: [
                  {
                    name: "Manage my Agency",
                    path: "/agency-information",
                  },
                  {
                    name: "Manage Clients",
                    path: "/client",
                  },
                  {
                    name: "Manage Vendors",
                    path: "/vendor",
                  },
                ],
              },
            ]
          : []),
        {
          name: "Reports",
          icon: <ReportIco />,
          children: [
            {
              name: "Set Goals",
              path: "/subscription-expired?id=17",
              check: "common",
            },
            {
              name: "Client Insights",
              path: "/subscription-expired?id=19",
              check: "common",
            },
            {
              name: "Agency Productivity",
              path: "/review-productivity",
            },
            {
              name: "Trends",
              path: "/subscription-expired?id=20",
              check: "common",
            },
            {
              name: "Dashboards",
              check: "common",
              path:
                storageData?.role === "Demo"
                  ? "/report-dashBoard"
                  : "/subscription-expired?id=21",
            },
          ],
        },
        {
          name: "Ai Assist",
          icon: <AIAssitIco />,
          children: [
            {
              name: "Understand Client Job",
              path: "/hiring-agent",
            },
            {
              name: "Draft Candidate Summary",
              path: "/recruiting-agent",
            },
            {
              name: "SoW Analysis",
              path: "/subscription-expired?id=23",
              check: "common",
            },
            {
              name: "Win/Loss Analysis",
              path: "/growth-agent",
              check: "common",
            },
          ],
        },
      ]),
  {
    name: "Send Feedback",
    path: "feedback",
    icon: <SendFeedBackIco />,
  },
];

export const AgencyPartner = ({ storageData, open }) => [
  {
    name: "Home",
    path: "/home",
    icon: <HomeIco />,
  },

  ...(!open
    ? [
        {
          name: "Jobs",
          icon: <JobNavIco />,
          path: true,
        },
        {
          name: "Candidates",
          icon: <CandidateIco />,
          path: true,
        },
        {
          name: "Matches",
          icon: <HyperQuickMatchIco />,
          path: true,
        },
        {
          name: "Projects",
          icon: <ProjectIco />,
          path: true,
        },

        ...(storageData?.role === "Admin"
          ? [
              {
                name: "CRM",
                icon: <CRMIco />,
                path: true,
              },
            ]
          : []),

        {
          name: "Reports",
          icon: <ReportIco />,
          path: true,
        },

        {
          name: "Ai Assist",
          icon: <AIAssitIco />,
          path: true,
        },
      ]
    : [
        {
          name: "Jobs",
          icon: <JobNavIco />,
          children: [
            {
              name: "Understand Client Job",
              path: "/enrich-job",
            },
            {
              name: "Submit Job",
              path: "/create-new-job",
            },
            {
              name: "View Active Jobs",
              path: "/jobs",
            },
            {
              name: "Job Flow Dashboard",
              path: "/job-krystal-path",
              icon: <KlarityCrystalpathIco />,
            },
          ],
        },
        {
          name: "Candidates",
          icon: <CandidateIco />,
          children: [
            {
              name: "Understand Candidates",
              path: "/resume-intelligence/create-candidate-resume",
            },
            {
              name: "Contractor Hub",
              path: "/candidates",
            },
            {
              name: "Source Contractors",
              path: "/build-pipeline",
              check: "common",
            },
            {
              name: "Agency Submitted Candidates",
              path: "/subscription-expired?id=100",
              check: "common",
            },
            {
              name: "Optimize Resume",
              path: "/subscription-expired?id=3",
              check: "common",
            },
            {
              name: "Conduct Assessments",
              path: "/subscription-expired?id=5",
              check: "common",
            },
          ],
        },
        {
          name: "Matches",
          icon: <HyperQuickMatchIco />,
          children: [
            {
              name: "View Leaderboard",
              path: "/tools/quick-match",
            },
            {
              name: "Match candidate to active Jobs",
              path: "/subscription-expired?id=6",
              check: "common",
            },
            {
              name: "Match Job to contractor Pool",
              path: "/subscription-expired?id=7",
              check: "common",
            },
          ],
        },
        {
          name: "Projects",
          icon: <ProjectIco />,
          children: [
            {
              name: "Understand Client SoW",
              path: "/sow-enrichment",
            },
            {
              name: "SoW Hub",
              path: "/judica",
            },
            {
              name: "Create SoW",
              path: "/subscription-expired?id=9",
              check: "common",
            },
            {
              name: "Manage Bids",
              path:
                storageData?.role === "Demo"
                  ? "/bid-management"
                  : "/subscription-expired?id=10",
              check: "common",
            },
            {
              name: "Create new Proposal",
              path: "/subscription-expired?id=24",
              check: "common",
            },
          ],
        },
        ...(storageData?.role === "Admin"
          ? [
              {
                name: "CRM",
                icon: <CRMIco />,
                children: [
                  {
                    name: "Manage my Org",
                    path: "/agency-information",
                  },
                  {
                    name: "Manage Clients",
                    path: "/client",
                  },
                  {
                    name: "Manage Agencies",
                    path: "/vendor",
                  },
                ],
              },
            ]
          : []),
        {
          name: "Reports",
          icon: <ReportIco />,
          children: [
            {
              name: "Set Goals",
              path: "/subscription-expired?id=17",
              check: "common",
            },
            {
              name: "Client/Agency Insights",
              path: "/subscription-expired?id=19",
              check: "common",
            },
            {
              name: "Review VMS Productivity",
              path: "/review-productivity",
            },
            {
              name: "Trends",
              path: "/subscription-expired?id=20",
              check: "common",
            },
            {
              name: "Dashboards",
              check: "common",
              path:
                storageData?.role === "Demo"
                  ? "/report-dashBoard"
                  : "/subscription-expired?id=21",
            },
          ],
        },
        {
          name: "Ai Assist",
          icon: <AIAssitIco />,
          children: [
            {
              name: "Understand Job Leaderboard",
              path: "/hiring-agent",
            },
            {
              name: "Prep Hiring team for interview",
              path: "/recruiting-agent",
            },
            {
              name: "SoW Analysis",
              path: "/subscription-expired?id=23",
              check: "common",
            },
            {
              name: "Agency Insights",
              path: "/growth-agent",
              check: "common",
            },
          ],
        },
      ]),
  {
    name: "Send Feedback",
    path: "feedback",
    icon: <SendFeedBackIco />,
  },
];

export const HiringTeam = ({ storageData, open }) => [
  {
    name: "Home",
    path: "/home",
    icon: <HomeIco />,
  },

  ...(!open
    ? [
        {
          name: "Jobs",
          icon: <JobNavIco />,
          path: true,
        },
        {
          name: "Candidates",
          icon: <CandidateIco />,
          path: true,
        },
        {
          name: "Matches",
          icon: <HyperQuickMatchIco />,
          path: true,
        },
        {
          name: "Projects",
          icon: <ProjectIco />,
          path: true,
        },

        ...(storageData?.role === "Admin"
          ? [
              {
                name: "CRM",
                icon: <CRMIco />,
                path: true,
              },
            ]
          : []),

        {
          name: "Reports",
          icon: <ReportIco />,
          path: true,
        },

        {
          name: "Ai Assist",
          icon: <AIAssitIco />,
          path: true,
        },
      ]
    : [
        {
          name: "Jobs",
          icon: <JobNavIco />,
          children: [
            {
              name: "Analyze a Job",
              path: "/enrich-job",
            },
            {
              name: "Submit Job",
              path: "/create-new-job",
            },
            {
              name: "View Active Jobs",
              path: "/jobs",
            },
            {
              name: "Job Dashboard",
              path: "/job-krystal-path",
              icon: <KlarityCrystalpathIco />,
            },
          ],
        },
        {
          name: "Candidates",
          icon: <CandidateIco />,
          children: [
            {
              name: "Analyze a Candidate",
              path: "/resume-intelligence/create-candidate-resume",
            },
            {
              name: "Talent Pool",
              path: "/candidates",
            },
            {
              name: "Hiring Pipeline",
              path: "/build-pipeline",
              check: "common",
            },
            {
              name: "Upload candidate referrals",
              path: "/subscription-expired?id=100",
              check: "common",
            },
            {
              name: "Curate Resume",
              path: "/subscription-expired?id=3",
              check: "common",
            },
            {
              name: "Onboard/Offbard Talent",
              path: "/subscription-expired?id=4",
              check: "common",
            },
            {
              name: "Conduct Assessments",
              path: "/subscription-expired?id=5",
              check: "common",
            },
          ],
        },
        {
          name: "Matches",
          icon: <HyperQuickMatchIco />,
          children: [
            {
              name: "Quick Assess Fit",
              path: "/tools/quick-match",
            },
            {
              name: "Match candidate to active Jobs",
              path: "/subscription-expired?id=6",
              check: "common",
            },
            {
              name: "Match Job to Talen Pool",
              path: "/subscription-expired?id=7",
              check: "common",
            },
            {
              name: "Assess Team Fit",
              path:
                storageData?.role === "Demo"
                  ? "/access-team-fit"
                  : "/subscription-expired?id=8",
              check: "common",
            },
            {
              name: "Succession Planning",
              path: "/subscription-expired?id=22",
              check: "common",
            },
          ],
        },
        {
          name: "Projects",
          icon: <ProjectIco />,
          children: [
            {
              name: "Analyze a SoW",
              path: "/sow-enrichment",
            },
            {
              name: "Active SoWs",
              path: "/judica",
            },
            {
              name: "Create a new SOW",
              path: "/subscription-expired?id=9",
              check: "common",
            },
            {
              name: "Award Contract",
              path:
                storageData?.role === "Demo"
                  ? "/bid-management"
                  : "/subscription-expired?id=10",
              check: "common",
            },
            {
              name: "Create a proposal",
              path: "/subscription-expired?id=24",
              check: "common",
            },
          ],
        },
        ...(storageData?.role === "Admin"
          ? [
              {
                name: "CRM",
                icon: <CRMIco />,
                children: [
                  {
                    name: "Manage my Hiring Team",
                    path: "/agency-information",
                  },
                  {
                    name: "Manage my Business Teams",
                    path: "/client",
                  },
                  {
                    name: "Manage Agencies",
                    path: "/vendor",
                  },
                ],
              },
            ]
          : []),
        {
          name: "Reports",
          icon: <ReportIco />,
          children: [
            {
              name: "Set Goals",
              path: "/subscription-expired?id=17",
              check: "common",
            },
            {
              name: "Talent Insights",
              path: "/subscription-expired?id=19",
              check: "common",
            },
            {
              name: "Review Hiring productivity",
              path: "/review-productivity",
            },
            {
              name: "Trends",
              path: "/subscription-expired?id=20",
              check: "common",
            },
            {
              name: "Dashboards",
              check: "common",
              path:
                storageData?.role === "Demo"
                  ? "/report-dashBoard"
                  : "/subscription-expired?id=21",
            },
          ],
        },
        {
          name: "Ai Assist",
          icon: <AIAssitIco />,
          children: [
            {
              name: "Prep for Interview",
              path: "/hiring-agent",
            },
            {
              name: "Summarize Candidate Profiles",
              path: "/recruiting-agent",
            },
            {
              name: "Proposal Readiness",
              path: "/subscription-expired?id=23",
              check: "common",
            },
            {
              name: "Growth Agent",
              path: "/growth-agent",
              check: "common",
            },
          ],
        },
      ]),
  {
    name: "Send Feedback",
    path: "feedback",
    icon: <SendFeedBackIco />,
  },
];

export const JobSeeker = ({ storageData, open }) => [
  {
    name: "Home",
    path: "/home",
    icon: <HomeIco />,
  },

  ...(!open
    ? [
        {
          name: "Jobs",
          icon: <JobNavIco />,
          path: true,
        },
        {
          name: "Candidates",
          icon: <CandidateIco />,
          path: true,
        },
        {
          name: "Matches",
          icon: <HyperQuickMatchIco />,
          path: true,
        },
        {
          name: "Projects",
          icon: <ProjectIco />,
          path: true,
        },

        ...(storageData?.role === "Admin"
          ? [
              {
                name: "CRM",
                icon: <CRMIco />,
                path: true,
              },
            ]
          : []),

        {
          name: "Reports",
          icon: <ReportIco />,
          path: true,
        },

        {
          name: "Ai Assist",
          icon: <AIAssitIco />,
          path: true,
        },
      ]
    : [
        {
          name: "Jobs",
          icon: <JobNavIco />,
          children: [
            {
              name: "Understand a Job Spec",
              path: "/enrich-job",
            },
            {
              name: "Create your own Job",
              path: "/create-new-job",
            },
            {
              name: "View your active Jobs",
              path: "/jobs",
            },
            {
              name: "Application Tracker",
              path: "/job-krystal-path",
              icon: <KlarityCrystalpathIco />,
            },
          ],
        },
        {
          name: "My Profile",
          icon: <CandidateIco />,
          children: [
            {
              name: "Analyze my resume",
              path: "/resume-intelligence/create-candidate-resume",
            },
            {
              name: "My Resumes",
              path: "/candidates",
            },
            {
              name: "Build Job Pipeline",
              path: "/build-pipeline",
              check: "common",
            },
            {
              name: "Curate Resume",
              path: "/subscription-expired?id=3",
              check: "common",
            },
            {
              name: "Skills Assessment",
              path: "/subscription-expired?id=5",
              check: "common",
            },
          ],
        },
        {
          name: "Matches",
          icon: <HyperQuickMatchIco />,
          children: [
            {
              name: "Do a quick match",
              path: "/tools/quick-match",
            },
            {
              name: "My Fit Scores",
              path: "/subscription-expired?id=6",
              check: "common",
            },
          ],
        },
        {
          name: "Projects",
          icon: <ProjectIco />,
          children: [
            {
              name: "Analyze a Project",
              path: "/sow-enrichment",
            },
            {
              name: "Open Projects",
              path: "/judica",
            },
            {
              name: "My Submissions",
              path: "/subscription-expired?id=9",
              check: "common",
            },
            {
              name: "Create a proposal",
              path: "/subscription-expired?id=24",
              check: "common",
            },
          ],
        },
        ...(storageData?.role === "Admin"
          ? [
              {
                name: "CRM",
                icon: <CRMIco />,
                children: [
                  {
                    name: "Manage my Agencies",
                    path: "/vendor",
                  },
                ],
              },
            ]
          : []),

        {
          name: "Ai Assist",
          icon: <AIAssitIco />,
          children: [
            {
              name: "Prep for Interview",
              path: "/hiring-agent",
            },
            {
              name: "Draft Outreach to Recruiter",
              path: "/recruiting-agent",
            },
            {
              name: "Understand Project readiness",
              path: "/subscription-expired?id=23",
              check: "common",
            },
            {
              name: "Understand my Fit",
              path: "/subscription-expired?id=10",
              check: "common",
            },
          ],
        },
      ]),
  {
    name: "Send Feedback",
    path: "feedback",
    icon: <SendFeedBackIco />,
  },
];
